import { useEffect, useState } from "react";
import "./services.css";
import {
  buildIndustrialContext,
  buildIndustrialItems,
} from "../../../Utils/buildContext";

function IndustrialServices({ lang }) {
  const context = buildIndustrialContext(lang);
  const items = buildIndustrialItems(lang);

  const [active, setActive] = useState(0);
  const [activePhoto, setActivePhoto] = useState(0);

  const total = items.length;

  useEffect(() => {
    if (!total) return;

    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 10000);

    return () => clearInterval(id);
  }, [total]);

  useEffect(() => {
    setActivePhoto(0);
  }, [active]);

  useEffect(() => {
    const photos = items[active]?.photoURL;

    if (!photos || photos.length <= 1) return;

    const id = setInterval(() => {
      setActivePhoto((prev) => (prev + 1) % photos.length);
    }, 5000);

    return () => clearInterval(id);
  }, [active, items]);

  const goPrev = () => {
    setActive((prev) => (prev - 1 + total) % total);
  };

  const goNext = () => {
    setActive((prev) => (prev + 1) % total);
  };

  return (
    <section className="services" id="industrial-services">
      <div className="title">
        <h2>{context.title}</h2>
        <p>{context.general_info}</p>
      </div>

      <div className="slider">
        <button
          type="button"
          className="slider-arrow slider-arrow-left"
          onClick={goPrev}
          aria-label="Previous slide"
        >
          &#10094;
        </button>

        <div className="slides">
          {items.map((item, i) => (
            <article
              key={i}
              className={`slide ${i === active ? "is-active" : ""}`}
              aria-hidden={i !== active}
            >
              <div className="slide-media">
                <div className="slide-media-frame">
                  <img
                    src={
                      Array.isArray(item.photoURL)
                        ? item.photoURL[i === active ? activePhoto : 0]
                        : item.photoURL
                    }
                    alt={item.title}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>

              <div className="service-item-text">
                <h2>{item.title}</h2>
                {item.points ? (
                  <ul className="service-points">
                    {item.points.map((point, index) => (
                      <li key={index}>
                        {point.before}
                        <strong>{point.bold}</strong>
                        {point.after}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>{item.text}</p>
                )}
              </div>
            </article>
          ))}
        </div>

        <button
          type="button"
          className="slider-arrow slider-arrow-right"
          onClick={goNext}
          aria-label="Next slide"
        >
          &#10095;
        </button>

        <div className="dots" aria-label="Slide pagination">
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`dot ${i === active ? "is-active" : ""}`}
              aria-label={`Go to slide ${i + 1}`}
              aria-current={i === active ? "true" : "false"}
              onClick={() => {
                setActive(i);
                setActivePhoto(0);
              }}
            />
          ))}
        </div>
      
      </div>
    </section>
  );
}

export default IndustrialServices;